
<div
  class="upload-btn"
  v-on:click="chosingFile"
  :title="uploadInstance.getSettings().tip"
>
  <div @click.stop="() => {}">
    <input
      type="file"
      :multiple="(uploadInstance.getConfig().upperLimit ?? 0) > 1"
      ref="fileInputRef"
      :accept="uploadInstance.getAllowedTypes()"
      v-on:change="choseFile"
    />
  </div>
  <div class="upload-box-content">
    <slot></slot>
  </div>
</div>
